var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectivesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 44H4C3.18 44 2.5 43.32 2.5 42.5C2.5 41.68 3.18 41 4 41H44C44.82 41 45.5 41.68 45.5 42.5C45.5 43.32 44.82 44 44 44Z",
    fill: "#CED1DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8V44H28.5V8C28.5 5.8 27.6 4 24.9 4H23.1C20.4 4 19.5 5.8 19.5 8Z",
    fill: "#CED1DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20V44H14V20C14 17.8 13.2 16 10.8 16H9.2C6.8 16 6 17.8 6 20Z",
    fill: "#CED1DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30V44H42V30C42 27.8 41.2 26 38.8 26H37.2C34.8 26 34 27.8 34 30Z",
    fill: "#CED1DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectivesIcon);
export default __webpack_public_path__ + "static/media/ObjectivesIcon.6a12651d6b1589a4f4fb2c1bb254312c.svg";
export { ForwardRef as ReactComponent };